import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';

type Props = {
    checked: boolean;
    onChange: (checked: boolean) => void;
};

export const AutoSearchCheckbox = ({ checked, onChange }: Props) => {
    return (
        <Checkbox.Option
            checked={checked}
            labelSize="secondary"
            onChange={(e) => {
                onChange(e.currentTarget.checked);
            }}
        >
            <FormattedMessage id="auctionsNearMe.mapView.searchAsIMove" />
        </Checkbox.Option>
    );
};
